import React from "react";
import QRCode from "react-qr-code";
import { useDispatch, useSelector } from "react-redux";
import { closeCameraModel } from "../../store/slices/modalSlice";
import { Modal } from "react-bootstrap";

interface QRModalProps {
  data: string;
  sessionId: string;
}

const CameraModel: React.FC<QRModalProps> = ({ data, sessionId }) => {
  const dispatch = useDispatch();

  const openModel = useSelector(
    (state: { modal: { cameraModel: boolean } }) => state.modal.cameraModel
  );

  const closeModel = () => {
    dispatch(closeCameraModel());
  };

  return (
    <Modal
      centered
      show={openModel}
      onHide={closeModel}
      backdrop="static"
      contentClassName="border-0 rounded-4 gap-3"
      dialogClassName="border-0"
    >
      <style>{`
        .qr-heading {
          font-size: 20px;
          font-weight: 700;
         
          margin-bottom: 20px;
        }
        .qr-step {
          font-size: 14px;
          color: #6c757d;
          line-height: 1.7;
        }
        .qr-arrow {
          font-size: 32px;
          line-height: 1;
          margin-bottom: -10px;
        }
        .qr-button {
        
          font-size: 14px;
          padding: 8px 20px;
          border-radius: 999px;
        }
      `}</style>

      <Modal.Header closeButton className="border-0 pb-0" />

      <Modal.Body className="px-4  pb-4 rounded-3">
        <div className="d-flex align-items-center justify-content-between gap-4">
          {/* Left: Text */}
          <div className="flex-grow-1 position-relative">
            <div className="qr-heading text-primary ">
              Scan QR to upload
              <br />
              docs from mobile
            </div>
            <div className="qr-step mb-4 ff-medium">
              <div>1. Open your phone's camera</div>
              <div>2. Scan the QR code</div>
              <div>3. Tap on the link</div>
            </div>
            <div className="d-flex align-items-center ">
              <div className="qr-button text-white bg-primary cursor-pointer">
                Ready to connect
              </div>
            </div>
            <div className="qr-arrow-dw">
              <img
                src="https://goodhand.b-cdn.net/Assets/Upload/arrow-qr.svg"
                alt=""
              />
            </div>
          </div>

          {/* Right: QR Code */}
          <div className="text-center">
            <div className="bg-white p-2 rounded ">
              <QRCode value={data} size={150} />
              <p className="text-muted mt-3" style={{ fontSize: "0.5rem" }}>
                {sessionId}
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CameraModel;
